<section class="main-content compliance-settings">

  <h1>{{'finraSettings.finraSettings' | translate}}</h1>
  <section class="spinner-container" *ngIf="loading$ | async">
    <mat-spinner [diameter]="40"></mat-spinner>
  </section>

  <section [hidden]="loading$ | async">
    <!--DRIVE LABEL SETTINGS-->
    <mat-card>
      <section class="spinner-container" *ngIf="labelLoading$ | async">
        <mat-spinner [diameter]="40"></mat-spinner>
      </section>
      <section [hidden]="labelLoading$ | async">
        <section class="actions-container" fxLayout="column" fxLayoutAlign="start start">
          <h2>{{'finraSettings.labelConfiguration' | translate}}</h2>
          <p class="grey-label">{{'finraSettings.labelText' | translate}}</p>

          <section fxLayout="column" *ngIf="isSuperAdmin() && !isLabelCreated">
            <div fxLayout="row">

            <ao-google-login
              [auto]="false"
              [clientId]="clientId"
              [scopes]="scopes"
              (loginSuccess)="googleLoginSuccess($event)"
              (loginError)="loginError()"
              [disabled]="googleLoading || !enableLabelBtn"
              [ngClass]="{'disabled-g-btn': googleLoading || !enableLabelBtn}"
              display-mode="content"
              authentication-mode="token"
              class="btn-background-blue btn-blue fw-500"

              id="gLogin">
              <div
                (click)="googleAuth()"
                [class.disabled]="!enableLabelBtn || googleLoading">
                <span>Create Label</span>
              </div>
            </ao-google-login>
            </div>
          </section>
          <section fxLayout="column" *ngIf="isLabelCreated">
            <h5>{{'finraSettings.form.sections.referenceCatalog' | translate}}</h5>
            <section fxLayout="row" fxLayoutAlign="space-between center">
              <mat-form-field class="full-width" appearance="fill">
                <mat-label>{{'finraSettings.form.fieldLabels.referenceCatalogId' | translate}}</mat-label>
                <input matInput [value]="labelSettings.referenceCatalogId" autocomplete="off" disabled>
              </mat-form-field>
            </section>
            <h5>{{'finraSettings.form.sections.googleDriveLabel' | translate}}</h5>
            <section fxLayout="column" fxLayoutAlign="space-between center">
              <section fxLayout="row">
                <div fxLayout="column" fxFlex="50">
                  <mat-form-field class="full-width" appearance="fill">
                    <mat-label>{{'finraSettings.form.fieldLabels.driveLabelId' | translate}}</mat-label>
                    <input matInput [value]="labelSettings.driveLabelId" autocomplete="off" disabled>
                  </mat-form-field>
                </div>
                <div fxLayout="column" fxFlex="50" style="margin-left: 30px">
                  <mat-form-field class="full-width" appearance="fill">
                    <mat-label>{{'finraSettings.form.fieldLabels.driveLabelFinalizedFieldId' | translate}}</mat-label>
                    <input matInput [value]="labelSettings.driveLabelFinalizedStatusFieldId" autocomplete="off"
                           disabled>
                  </mat-form-field>
                </div>
              </section>
              <section fxLayout="row">
                <div fxLayout="column" fxFlex="50">
                  <mat-form-field class="full-width" appearance="fill">
                    <mat-label>{{'finraSettings.form.fieldLabels.driveLabelFinalizedStatusFieldValueId' | translate}}</mat-label>
                    <input matInput [value]="labelSettings.driveLabelFinalizedStatusFieldValueId" autocomplete="off"
                           disabled>
                  </mat-form-field>
                </div>
                <div fxLayout="column" fxFlex="50"  style="margin-left: 30px">
                  <mat-form-field class="full-width" appearance="fill">
                    <mat-label>{{'finraSettings.form.fieldLabels.driveLabelFinalizedAndExportedStatusFieldValueId' | translate}}</mat-label>
                    <input matInput [value]="labelSettings.driveLabelFinalizedAndExportedStatusFieldValueId"
                           autocomplete="off" disabled>
                  </mat-form-field>
                </div>

              </section>

            </section>
          </section>
        </section>
      </section>
    </mat-card>

    <!-- PROJECT SETTINGS-->

    <mat-card class="card-margin-top">
      <section class="spinner-container" *ngIf="projectLoading$ | async">
        <mat-spinner [diameter]="40"></mat-spinner>
      </section>
      <section [hidden]="projectLoading$ | async">
        <section class="actions-container" fxLayout="column" fxLayoutAlign="start start">

          <h2>{{'finraSettings.storageConfiguration' | translate}}</h2>
          <p class="grey-label">{{'finraSettings.storageText' | translate}}</p>
          <section fxLayout="column" *ngIf="isSuperAdmin() && !isProjectSettingsCreated"
                   fxLayoutAlign="start  space-between">
            <section fxLayout="row">
              <form [formGroup]="projectForm">
                <div fxLayout="column" fxFlex="50">
                  <mat-form-field class="full-width" appearance="fill">
                    <mat-label>GCP project</mat-label>
                    <input type="text" matInput formControlName="gcpProject" autocomplete="off">
                  </mat-form-field>
                </div>
                <div fxLayout="column" fxFlex="50" style="margin-left: 30px">
                  <mat-form-field class="full-width" appearance="fill">
                    <mat-label>GCS Bucket</mat-label>
                    <input type="text" matInput formControlName="bucketName" autocomplete="off">
                  </mat-form-field>
                </div>
              </form>
            </section>
            <div fxLayout="row">
              <button mat-button class="btn-background-blue fw-500"
                      [disabled]="!getEnableProjectSettingsBtn()"
                      (click)="enterProjectSettings()">
                Save
              </button>
            </div>
          </section>
          <section fxLayout="row" *ngIf="isProjectSettingsCreated">
            <div fxLayout="column" fxFlex="50">
              <mat-form-field class="full-width" appearance="fill">
                <mat-label>{{'finraSettings.form.fieldLabels.gcpProject' | translate}}</mat-label>
                <input matInput [value]="projectSettings.projectId" autocomplete="off" disabled>
              </mat-form-field>
            </div>
            <div fxLayout="column" fxFlex="50" style="margin-left: 30px">
              <mat-form-field class="full-width" appearance="fill">
                <mat-label>{{'finraSettings.form.fieldLabels.bucket' | translate}}</mat-label>
                <input matInput [value]="projectSettings.temporaryBucket" autocomplete="off" disabled>
              </mat-form-field>
            </div>
          </section>
        </section>
      </section>
    </mat-card>

  </section>
</section>
